import React from 'react';

//TODO: change the design of Not Found Page

const NotFound = () => <div className='NotFound'><h1>Not Found</h1></div>

export default NotFound
